import React, { Component } from 'react';
import { Upload, Button, message } from 'antd';
import $, { xToken } from '../../common/AjaxRequest';

class UploadFile extends Component {
    beforeUpload = file => {
        const { size = 30, number = 10, fileList = [] } = this.props;
        const isLtSize= file.size / 1024 / 1024 <= size;
        if (fileList.length >= number) {
            message.warning(`最多上传${number}个附件`);
            return false;
        }
        if (!isLtSize) {
            message.warning(`文件大小不能超过${size}M`);
            return false;
        }
    }

    handleChange = ({file, fileList, event}) => {
        if (file.status == "done") {
            if (file.response.error) {  
                message.error(file.response.error);
                file.status = 'removed';
                const fileData = [...this.props.fileList];
                const index = fileData.indexOf(file);
                fileList.splice(index, 1);
            } else if (file.response.success) {
                message.success('上传附件成功');
            }
        }
        this.props.onChange(file, fileList);
    }

    handleRemove = file => {
        const { status, deletable } = file;
        if (status === "error") {
            return true;
        }
        if (deletable === false) {
            return false;
        }
        const { removeUrl } = this.props;
        const options = {
            method: 'POST',
            url: removeUrl,
            data: {
                fileMetaId: file.response.fileMetaId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { accept='',data, fileList, children, uploadUrl, disabled = false, text, type = 'ghost', style = {}, showUploadList = true } = this.props;
        const settings = {};
        // fileList没传时，不置空，以防onchange只调用一次
        if (fileList) {
            settings.fileList = fileList;
        }
        return (
            <Upload
                action={uploadUrl}
                data={{
                    ...data,
                    curUserId: sessionStorage.userId,
                    curEmployeeCode: sessionStorage.curEmployeeCode || '',
                }}
                beforeUpload={this.beforeUpload}
                onChange={this.handleChange}
                onRemove={this.handleRemove}
                showUploadList={showUploadList}
                accept={accept}
                headers={xToken}
                style={style}
                {...settings}
            >
                {children || <Button style={{width: 80}} type={type} disabled={disabled}>{text || '选择文件'}</Button>}
            </Upload>
        )
    }
}

export default UploadFile;


// WEBPACK FOOTER //
// ./src/components/common/UploadFile.js